(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-access-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-access-code')) {
    customElements.define('sr-access-code', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        const fallback = this.querySelector('[name="password"]');
        const cells = [...this.querySelectorAll('.sr-code-cell')];
        const glyphs = [...this.querySelectorAll('.sr-code-glyph')];
        const form = this.closest('form');
        const error = this.querySelector('.sr-code-error');
        if (!fallback || cells.length !== 6 || glyphs.length !== 6 || !form || !error) return;
        this.controller = new AbortController();
        this.maskTimers = [];
        const options = { signal: this.controller.signal };
        const focusCell = index => { cells[index].focus(); cells[index].select(); };
        // The password inputs retain their real values; only these decorative glyphs change.
        const paint = (index, reveal = false) => {
          clearTimeout(this.maskTimers[index]);
          const value = cells[index].value;
          glyphs[index].toggleAttribute('data-masked', Boolean(value) && !reveal);
          glyphs[index].textContent = value ? (reveal ? value : '●') : '';
          if (reveal && value) this.maskTimers[index] = setTimeout(() => paint(index), 250);
        };
        const maskAll = () => cells.forEach((cell, index) => paint(index));
        this.maskAll = maskAll;
        const clearError = () => {
          clearTimeout(this.denialTimer);
          error.textContent = '';
          cells.forEach(cell => cell.removeAttribute('aria-invalid'));
          this.removeAttribute('data-error');
        };
        const deny = () => {
          clearTimeout(this.denialTimer);
          error.textContent = 'ACCESS DENIED';
          cells.forEach(cell => cell.setAttribute('aria-invalid', 'true'));
          this.denialTimer = setTimeout(clearError, 1400);
        };
        const sync = () => { fallback.value = cells.map(cell => cell.value).join(''); };
        const distribute = (value, start) => {
          const characters = Array.from(value.trim());
          if (!characters.length) return;
          clearError();
          const from = characters.length >= 6 ? 0 : start;
          characters.slice(0, 6 - from).forEach((character, offset) => {
            cells[from + offset].value = character;
            paint(from + offset, true);
          });
          sync();
          focusCell(Math.min(from + characters.length, 5));
        };
        cells.forEach((cell, index) => {
          cell.disabled = false;
          cell.addEventListener('focus', () => cell.select(), options);
          cell.addEventListener('paste', event => {
            const text = event.clipboardData?.getData('text');
            if (!text) return;
            event.preventDefault();
            distribute(text, index);
          }, options);
          cell.addEventListener('input', event => {
            if (event.isComposing) return;
            if (Array.from(cell.value).length > 1 || (event.data && Array.from(event.data).length > 1)) {
              distribute(event.data || cell.value, index);
              return;
            }
            clearError();
            sync();
            paint(index, Boolean(cell.value) && !event.inputType?.startsWith('delete'));
            if (cell.value && index < 5) focusCell(index + 1);
          }, options);
          cell.addEventListener('compositionend', () => {
            if (Array.from(cell.value).length > 1) distribute(cell.value, index);
            else { clearError(); sync(); paint(index, Boolean(cell.value)); if (cell.value && index < 5) focusCell(index + 1); }
          }, options);
          cell.addEventListener('keydown', event => {
            if (event.key === 'Backspace' && !cell.value && index > 0) {
              event.preventDefault();
              cells[index - 1].value = '';
              clearError();
              sync();
              paint(index - 1);
              focusCell(index - 1);
            } else if (event.key === 'ArrowLeft' && index > 0) {
              event.preventDefault(); focusCell(index - 1);
            } else if (event.key === 'ArrowRight' && index < 5) {
              event.preventDefault(); focusCell(index + 1);
            }
          }, options);
        });
        const initialValue = fallback.value;
        fallback.type = 'hidden';
        fallback.required = false;
        fallback.hidden = true;
        this.querySelector('.sr-code-label').htmlFor = cells[0].id;
        this.setAttribute('data-enhanced', '');
        this.querySelector('.sr-code-cells').hidden = false;
        if (initialValue) Array.from(initialValue).slice(0, 6).forEach((character, index) => { cells[index].value = character; });
        sync();
        maskAll();
        const acceptAutofill = () => {
          const characters = Array.from(fallback.value);
          if (characters.length !== 6) return;
          clearError();
          cells.forEach((cell, index) => { cell.value = characters[index]; });
          maskAll();
        };
        fallback.addEventListener('input', acceptAutofill, options);
        fallback.addEventListener('change', acceptAutofill, options);
        form.addEventListener('submit', event => {
          sync();
          maskAll();
          const emptyIndex = cells.findIndex(cell => !cell.value);
          if (emptyIndex !== -1) { event.preventDefault(); focusCell(emptyIndex); cells[emptyIndex].reportValidity(); }
        }, options);
        form.addEventListener('reset', () => { queueMicrotask(() => { cells.forEach(cell => { cell.value = ''; }); clearError(); sync(); maskAll(); }); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) maskAll(); }, options);
        window.addEventListener('blur', maskAll, options);
        window.addEventListener('pagehide', maskAll, options);
        document.addEventListener('visibilitychange', () => { if (document.hidden) maskAll(); }, options);
        const modal = this.closest('.password-modal-background');
        const section = this.closest('.shopify-section');
        if (!modal) { if (this.hasAttribute('data-error')) deny(); return; }
        let previousFocus;
        let wasOpen = false;
        const updateModal = () => {
          const open = modal.classList.contains('visible');
          modal.setAttribute('aria-hidden', String(!open));
          if (open && !wasOpen) {
            previousFocus = document.activeElement;
            const index = Math.max(0, cells.findIndex(cell => !cell.value));
            focusCell(index);
            this.focusFrame = requestAnimationFrame(() => {
              this.focusFrame = requestAnimationFrame(() => {
                if (this.isConnected && modal.classList.contains('visible') && !modal.contains(document.activeElement)) focusCell(index);
              });
            });
          }
          if (!open && wasOpen) { cancelAnimationFrame(this.focusFrame); maskAll(); if (previousFocus?.isConnected) previousFocus.focus(); }
          wasOpen = open;
        };
        this.observer = new MutationObserver(updateModal);
        this.observer.observe(modal, { attributes: true, attributeFilter: ['class'] });
        section?.querySelectorAll('.password-store-owner, .password-store-owner-mobile').forEach(trigger => {
          trigger.setAttribute('role', 'button');
          trigger.tabIndex = 0;
          trigger.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); trigger.click(); }
          }, options);
        });
        modal.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); modal.classList.remove('visible'); }
          if (event.key !== 'Tab') return;
          const controls = [...modal.querySelectorAll('button, input:not([type="hidden"]), [tabindex="0"]')].filter(control => !control.disabled && control.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }, options);
        if (this.hasAttribute('data-error')) { modal.classList.add('visible'); deny(); }
        updateModal();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.focusFrame);
        clearTimeout(this.denialTimer);
        this.maskAll?.();
        this.maskTimers?.forEach(timer => clearTimeout(timer));
        this.maskAll = null;
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
